import React, { useEffect, useState } from 'react';
import * as S from './styles';
import events from './eventsData';
import chat from '../../../assets/icons/icon-chat-blue.png'
import api from '../../../services/api';
import Tooltip from "../../tooltip";
import { BodyG, BodyM, BodyP, TaglineM, TaglineP } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';

const Updates = () => {
  const [isLoading, setIsloading] = useState(true)
  const [updates, setUpdates] = useState([])

  const getUpdates = async () => {
    try {
      const response = await api.get(`/home/produtos-atualizados`);
      const responseSave = response.data.data;

      const formattedData = responseSave.map((item) => ({
        data_atualizacao: item.data_atualizacao,
        fabricante: item.fabricante,
        nome_comercial: item.nome_comercial,
        principio_ativo: item.principio_ativo,
        classes: item.classes,
      }));

      setUpdates(formattedData);

      setIsloading(false)
    } catch (error) {
      console.error("Erro ao buscar Atualizações:", error);
    }
  };

  useEffect(() => {
    getUpdates()
  }, [])

  return (
    <S.Container>
      <S.Header>
        <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>Atualizações</BodyG>

        <S.ViewAll onClick={() => window.location = '/solicitar'}>
          <img src={chat} alt="" style={{width:"16px"}}/>
          
          <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800} cursor="pointer">SOLICITAR PRODUTO</TaglineM>
        </S.ViewAll>
      </S.Header>

      <S.CardsScroll>
        {!isLoading ? (
          updates.map((data, index) => (
            <S.EventCard key={index}>

              <S.EventInfo>
                <S.EventMeta>
                  <TaglineP color={theme.colors.gray.Cinza_7}>
                    {data.data_atualizacao}
                  </TaglineP>
                </S.EventMeta>

                <S.FarmWrapper>
                  <S.FieldScroll>
                    <TaglineP color={theme.colors.gray.Cinza_2}>{(data.classes && data.classes.length > 0) ? data.classes : "Não encontrado"}</TaglineP>
                  </S.FieldScroll>
                </S.FarmWrapper>
              </S.EventInfo>

              <S.NomeComercialScroll>
                <BodyM color={theme.colors.gray.Cinza_2} fontWeight={700}>
                  {data.nome_comercial}
                </BodyM>
              </S.NomeComercialScroll>

              <S.EventInfo>
                <S.EventMeta>
                  <S.NomeComercialScroll>
                    <BodyP color={theme.colors.gray.Cinza_2}>
                      {data.fabricante}
                    </BodyP>
                  </S.NomeComercialScroll>
                </S.EventMeta>

                <S.FarmWrapper>
                  <Tooltip content={data.principio_ativo} animation="fade" delay={[100, 100]} arrow={true} theme="light" placement="bottom">
                    <S.Active>{data.principio_ativo}</S.Active>
                  </Tooltip>
                </S.FarmWrapper>
              </S.EventInfo>

            </S.EventCard>
          ))
        ) : (
          <S.EventCard>
            <S.EventInfo>
              <S.EventMeta>
                <TaglineP color={theme.colors.gray.Cinza_7}>Carregando...</TaglineP>
              </S.EventMeta>
              <S.FarmWrapper>
                <S.FieldScroll>
                  <TaglineP color={theme.colors.gray.Cinza_2}>Carregando...</TaglineP>
                </S.FieldScroll>
              </S.FarmWrapper>
            </S.EventInfo>
            <S.NomeComercialScroll>
              <BodyM color={theme.colors.gray.Cinza_2} fontWeight={700}>Carregando...</BodyM>
            </S.NomeComercialScroll>
            <S.EventInfo>
              <S.EventMeta>
                <S.NomeComercialScroll>
                  <BodyP color={theme.colors.gray.Cinza_2}>Carregando...</BodyP>
                </S.NomeComercialScroll>
              </S.EventMeta>
              <S.FarmWrapper>
                <S.Active>Carregando...</S.Active>
              </S.FarmWrapper>
            </S.EventInfo>
          </S.EventCard>
        )}
      </S.CardsScroll>
    </S.Container>
  );
};
export default Updates;